var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeVotesSelec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6893 6.64913L13.6873 6.64604L10.7495 2.08599L7.81388 6.64268C7.81343 6.6434 7.81297 6.64411 7.81251 6.64482C7.62411 6.93824 7.3333 7.17133 6.97572 7.28063L13.6893 6.64913ZM13.6893 6.64913C13.8784 6.94068 14.1687 7.1719 14.5248 7.28047C14.8828 7.38965 15.2658 7.36134 15.6018 7.20506L15.6018 7.20511L15.6123 7.20013L19.033 5.57044M13.6893 6.64913L19.033 5.57044M19.033 5.57044L16.6801 14.2115H4.81976L2.46695 5.57044L5.88762 7.20013L5.88762 7.20014L5.8922 7.2023C6.22954 7.36134 6.61519 7.39083 6.97571 7.28063L19.033 5.57044Z",
    fill: "#EF364E",
    stroke: "#EF364E",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8029 2.19617L7.72817 7.0279L2.01794 4.83166L5.09268 14.9344H16.5131L19.5879 4.83166L14.3169 7.0279L10.8029 2.19617Z",
    fill: "#EF364E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeVotesSelec);
export default __webpack_public_path__ + "static/media/freeVotesSelec.c0e7ccf1f4ebbbfc3ee7a4f0f9f7f901.svg";
export { ForwardRef as ReactComponent };